import React from 'react';
import Box from '@mui/material/Box';
import LogoLoader from '../LogoLoader';

function PageLoader() {
  return (
    <Box
      position="fixed"
      zIndex="2000"
      paddingBottom={{ xs: 30, lg: 30 }}
      height="100%"
      width="100%"
      sx={{ bgcolor: 'white' }}
    >
        <Box
          position="absolute"
          height="80vh"
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
            <LogoLoader/>
        </Box>
    </Box>
  );
}

export default PageLoader;
